import { render, staticRenderFns } from "./ucenter.vue?vue&type=template&id=3fbd4470"
import script from "./ucenter.vue?vue&type=script&lang=js"
export * from "./ucenter.vue?vue&type=script&lang=js"
import style0 from "./ucenter.vue?vue&type=style&index=0&id=3fbd4470&prod&lang=css"
import style1 from "./ucenter.vue?vue&type=style&index=1&id=3fbd4470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports